import { HeatmapContact } from './useHeatmapData';
import { HeatmapCenter } from './useCentersData';

export const calculateBounds = (contacts: HeatmapContact[]): google.maps.LatLngBounds | null => {
  if (!contacts || contacts.length === 0 || !window.google) {
    return null;
  }

  try {
    const bounds = new google.maps.LatLngBounds();
    contacts.forEach(contact => {
      if (contact.address?.lat && contact.address?.lon) {
        bounds.extend(new google.maps.LatLng(contact.address.lat, contact.address.lon));
      }
    });
    return bounds;
  } catch (error) {
    console.error('Error calculating bounds:', error);
    return null;
  }
};

export const calculateBoundsWithCenters = (
  contacts: HeatmapContact[],
  centers: HeatmapCenter[]
): google.maps.LatLngBounds | null => {
  if (((!contacts || contacts.length === 0) && (!centers || centers.length === 0)) || !window.google) {
    return null;
  }

  try {
    const bounds = new google.maps.LatLngBounds();

    // Add contacts to bounds
    if (contacts && contacts.length > 0) {
      contacts.forEach(contact => {
        if (contact.address?.lat && contact.address?.lon) {
          bounds.extend(new google.maps.LatLng(contact.address.lat, contact.address.lon));
        }
      });
    }

    // Add centers to bounds
    if (centers && centers.length > 0) {
      centers.forEach(center => {
        if (center.lat && center.lng && !isNaN(center.lat) && !isNaN(center.lng)) {
          bounds.extend(new google.maps.LatLng(center.lat, center.lng));
        }
      });
    }

    return bounds;
  } catch (error) {
    console.error('Error calculating bounds with centers:', error);
    return null;
  }
};
